export const TRIAL_DURATION = 30;
export const TRIAL_ONGOING = 'trial-ongoing';
export const TRIAL_ENDED = 'trial-ended';
export const SUBSCRIPTION_ONGOING = 'subscription-ongoing';
export const SUBSCRIPTION_CANCELLED = 'subscription-cancelled';
